import React from 'react';
import styled from 'styled-components';

import { SearchSelect } from '../SearchSelect';

import Option from './components/Option';
import SingleValue from './components/SingleValue';

import { ISelector } from './types';

import { selectStyles } from './styles';

const Selector: React.FC<ISelector> = props => {
  const {
    className = '',
    defaultValue = '',
    options = [],
    selected = {
      id: '',
      value: '',
    },
    onSelected = () => null,
  } = props;

  const handleChange = (opt: any) =>
    onSelected({ id: opt?.value, value: opt?.label });

  const value = {
    value: selected.id as string,
    label: (selected.value || defaultValue) as string,
  };

  const selectOptions = options.map((o: LT.IOption) => ({
    value: o.id as string,
    label: o.value as string,
  }));

  return (
    <StyledSelector className={className}>
      <SearchSelect
        value={value}
        options={selectOptions}
        onChange={handleChange}
        customStyles={selectStyles}
        CustomSingleValue={SingleValue}
        CustomDropdownIndicator={() => null}
        CustomOption={Option}
        isSearchable={false}
        menuShouldScrollIntoView
      />
    </StyledSelector>
  );
};

const StyledSelector = styled.div`
  position: relative;
  cursor: pointer;
`;

export default Selector;
